import styled from '@emotion/styled'
import _ from 'lodash'
import L1Tip from './L1Tip'
import { Theme } from '@emotion/react'
import { ValiditySeverity } from '@fusion-advantage/formlib'

type L1TitleTextProps = {
	title?: string,
	validity?: ValiditySeverity|null,
	validityMessage?: string,
	disabled?: boolean,
}

type L1TitleTextSpanProps = {
	disabled?: boolean
} & { theme: Theme }

const L1TitleTextSpan = styled.span(({theme, disabled}: L1TitleTextSpanProps) => ({
	opacity: disabled ? theme.disabledOpacity : 1,
}))

const L1TitleText = ({title, validity, validityMessage, disabled}: L1TitleTextProps) => {
	return (
		<L1TitleTextSpan disabled={disabled}>
			{
				validity === ValiditySeverity.Error ? <L1Tip icon="error" tip={validityMessage} leftPad={false} /> :
				validity === ValiditySeverity.Warning ? <L1Tip icon='warning' tip={validityMessage} leftPad={false} /> : null
			}
			{title}
		</L1TitleTextSpan>
	)
}

export default L1TitleText
